module.exports = __webpack_public_path__ + "img/1052de5.svg";